import { useMutation } from "@apollo/client";
import { evictFields } from "../../../helpers/cache";
import { toast } from "react-toastify";
import { CREATE_MANUAL_CREATED_SITE } from "../created-site.queries";
import {
  CreateManualCreatedSiteMutation,
  CreateManualCreatedSiteMutationVariables,
} from "../../../__generated__/CreateManualCreatedSiteMutation";

export const useCreateManualCreatedSite = () => {
  const [mutate, { loading }] = useMutation<
    CreateManualCreatedSiteMutation,
    CreateManualCreatedSiteMutationVariables
  >(CREATE_MANUAL_CREATED_SITE, {
    refetchQueries: ["CustomerQuery", "CreatedSitesQuery"],
    update(cache) {
      evictFields(cache, ["createdSite", "createdSites", "customer", "customers"]);
    },
  });

  const createManualCreatedSite = async (
    variables: CreateManualCreatedSiteMutationVariables
  ): Promise<number | null> => {
    if (loading) return null;
    try {
      const { data } = await mutate({ variables });
      if (data?.createManualCreatedSite?.ok) {
        toast.success("Le site a été ajouté avec succès");
        return data.createManualCreatedSite.createdSiteId ?? null;
      }
      toast.error(data?.createManualCreatedSite?.error ?? "Une erreur est survenue");
      return null;
    } catch (error: any) {
      const isForbidden = error?.graphQLErrors?.some(
        (e: any) =>
          e?.extensions?.code === "FORBIDDEN" ||
          e?.message?.toLowerCase().includes("forbidden")
      );
      toast.error(
        isForbidden
          ? "Action réservée aux administrateurs"
          : error?.message ?? "Une erreur est survenue"
      );
      return null;
    }
  };

  return { createManualCreatedSite, loading };
};
